<template>
    <div class="card card-rounded card-transparent" >
        <div class="card-header">Reserverade tider</div>
        <div class="card-body" v-if="reservations.length">
            <div>
                <div v-for="booking in reservations" class="border rounded mt-2 mb-2 p-2 schedule-slot">
                    <div>
                        <div class="h6 font-weight-bold">{{getDateTime(booking.schedule.start, booking.schedule.end)}}</div>
                        <div class="text-muted">{{booking.schedule.location.address}} {{booking.schedule.location.city ? booking.schedule.location.city.name : ''}}</div>
                        <div class="text-muted">{{getPrice(booking)}} - {{booking.treatment.name}}</div>
                        <div class="text-muted"><img class="round-profile-picture" :src="'/therapist_profile_picture/' +
                        booking.schedule.therapist.profile_picture_path"> {{booking.schedule.therapist.user.name}}</div>
                    </div>
                    <div>
                        <button type="button" v-on:click="removeReservation(booking.id)"
                                class="btn btn-outline-danger text-danger"><i class="fa fa-times" aria-hidden="true"></i> Ta bort
                        </button>
                    </div>

                </div>
                <div v-if="user_id">
                    <p>
                        <h5>Avbokningsregler</h5>
                        <div v-if="company.cancel_booking_rule_type == 1">
                            Avbokning senast kl. {{company.cancel_booking_before_time}} {{company.cancel_booking_before_days}} dag(ar) innan behandlingen.
                        </div>
                        <div v-else>
                            Avbokning senast {{company.cancel_booking_before_hours}} timmar innan behandlingen.
                        </div>
                        <hr>
                        <div>Reservationer är giltiga 10 minuter efter den senast gjorda reservationen, därefter blir de schemalagda
                            tiderna tillgängliga för andra användare att boka.</div>
                    </p>
                    <div><label><input type="checkbox" v-model="termsAccepted">
                        Jag godkänner <a href="/terms-and-conditions" target="_blank">användarvillkoren</a>, avbokningsreglerna samt <a href="/integrity_policy" target="_blank">integritetspolicyn</a> </label>
                    </div>
                    <button  type="button" id="book_button" v-on:click="emitPayment" class="btn btn-primary" :disabled="!termsAccepted"><i class="fa fa-check"></i> Slutför din bokning</button>
                </div>

                <div v-else>
                    <div class="h4 pt-2">Slutför din bokning</div>
                    <a :href="/login/" class="btn btn-primary"> <i class="fa fa-sign-in"></i> Logga in </a>
                    <a :href="'/register/'+company.id" class="btn btn-primary"> <i class="fa fa-user-plus"></i> Registrera</a>

                </div>

            </div>
        </div>
        <div v-else class="card-body">
            <strong>Inga reserverade tider</strong>
            <br>
            <span>Gör en reservation i bokningskalendern nedanför.
                Reservationer är giltiga 10 minuter efter den senast gjorda reservationen, därefter blir de schemalagda
            tiderna tillgängliga för andra användare att boka.</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "reservations",
        props: ["user_id", 'company',  'consultant'],
        data() {
            return {
                reservations: [],
                baseURL: window.location.hostname + '/login',
                termsAccepted: false,
            }
        },
        methods: {
            getDateTime(dateString, dateStringEnd){
                return moment(dateString).format('YYYY-MM-DD') + ' kl. ' + moment(dateString).format('HH:mm') + ' - ' + moment(dateStringEnd).format('HH:mm');
            },
            listen() {
                if(this.user_id != null) {
                    Echo.private('reservations.' + this.user_id)
                        .listen("ReservationDone", (e) => {
                            this.getReservations();
                        });
                    Echo.private('expired_reservations.' + this.user_id)
                        .listen("ReservationsHaveExpired", (e) => {
                            flash("Reservationer har utgått", 'error');
                            this.$emit('reservationsExpired');
                            this.getReservations();
                        });
                } else {
                    Echo.channel('reservations.session.' + window.Laravel.sessionId)
                        .listen("ReservationDone", (e) => {
                            this.getReservations();
                        });
                }
            },
            getPrice(booking){
                if(booking.treatment.treatment_price){
                    if(this.consultant || (booking.subvention_used == 0 && booking.session_id == 1 )) {
                        return booking.treatment.treatment_price.total_sum + ' kr';
                    }else {
                        return booking.treatment.treatment_price.subv_total_sum + ' kr';
                    }
                }

                return 'Odefinierat pris';
            },
            getReservations() {
                let self = this;
                axios.get('/reservations?company_id='+this.company.id)
                    .then(response => {
                        self.reservations = response.data;
                    });
            },
            emitPayment() {
                this.$eventHub.$emit('showpayinfo');
            },
            removeReservations() {
                this.reservations = [];
            },
            removeReservation(id) {
                axios.post('/reservations/delete', {id: id}).then((res) => {
                    this.reservations = this.reservations.filter(function (reservation) {
                        return id != reservation.id;
                     });
                    this.$emit('reservationCanceled');
                });

                return false;
            },
            dateFormat: function (schedule) {
                return moment(schedule.start).format("YY-MM-DD") + " " + moment(schedule.start).format("HH:mm") + " - " + moment(schedule.end).format("HH:mm");
            },
            getLoginURL: function () {
                return window.location.hostname + '/login';
            }
        },
        computed: {},
        mounted() {
            this.listen();
            this.getReservations();
            this.$eventHub.$on('showpayinfo', function () {
            });
        }
    }
</script>
<style scoped>
    .schedule-slot{
        display: flex;
        justify-content: space-between;
    }

</style>
